import React from 'react';

// Shared hero for every wizard step. The StepHeader pips at the top of
// the wizard already carry the "where am I" cue, so this header keeps
// to: eyebrow (section label), title, lede. No drop-cap numbering —
// Paul nixed the look in V1-F44.
export default function StepHero({ sectionLabel, title, lede, eyebrowAction, children }) {
  return (
    <header>
      <div style={eyebrowRowStyle}>
        <span style={eyebrowStyle}>{sectionLabel}</span>
        {eyebrowAction}
      </div>
      <h1 style={titleStyle}>{title}</h1>
      {lede && <p style={ledeStyle}>{lede}</p>}
      {children}
    </header>
  );
}

const eyebrowRowStyle = { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '12px' };
const eyebrowStyle = { fontSize: '13px', color: 'var(--accent)', fontWeight: 500 };
const titleStyle = {
  fontFamily: 'var(--display)',
  fontWeight: 500,
  fontSize: '40px',
  letterSpacing: '-0.02em',
  lineHeight: 1.05,
  margin: '6px 0 0',
  color: 'var(--ink)',
};
const ledeStyle = {
  fontSize: '16px',
  lineHeight: 1.55,
  color: 'var(--ink2)',
  margin: '12px 0 28px',
  maxWidth: '620px',
};
